/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAssetsTokens.vue?vue&type=template&id=4694ab3c&scoped=true"
import script from "./popAssetsTokens.vue?vue&type=script&lang=js"
export * from "./popAssetsTokens.vue?vue&type=script&lang=js"
import style0 from "./popAssetsTokens.vue?vue&type=style&index=0&id=4694ab3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694ab3c",
  null
  
)

export default component.exports